import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const searchFavorites = async () => {
  return await apiClient.get(ENDPOINTS.FAVORITES);
};
